<template>
  <div id="dashboard" class="main-container">
    
    
    <h2 v-if="!currentUser" class="title is-spaced is-at-header is-hidden-desktop">Vols afegir una iniciativa?</h2>
    <router-link v-if="!currentUser" to="/login" class="button is-danger is-hidden-desktop zis-at-header">Registra't i afegeix-la!</router-link>

    <div v-if="!currentUser || (currentUser && currentUser.emailVerified)">

      <p class="desc has-margin-top-3">
        En temps de Covid-19 són moltes les iniciatives solidàries que sorgeixen al nostre entorn; projectes que han transformat part de la seva activitat econòmica convencional a una activitat que, sense esperar res a canvi, reverteix a tota la comunitat. Aquestes iniciatives inverteixen de manera solidària material, temps, diners i energia pel bé comú.

      Suport d'arrel proposa aportar recursos a totes aquestes iniciatives per tal que puguin seguir duent a terme les activitats.

      SUPORT ja que confinades des de casa, tenim l'oportunitat de descobrir i aportar a aquestes iniciatives allò que necessiten, tot fent un retorn des de la comunitat.

      D'ARREL perquè les nostres aportacions fan possible que les iniciatives siguin més viables i sostenibles.

      En temps d'emergència les arrels d'una economia solidària continuen agafant forma a la nostra comarca, és cosa de totes que puguin seguir expendint-se i arrelant fort. Cuidem-nos, entre totes i des de tots els espais imaginables.
      </p>

      <!-- <img src="@/assets/images/SuportdArrel-text.png" /> -->

      <section class="section">
        <AllBoxes></AllBoxes>
      </section>

      <h2 class="title">Vols afegir una iniciativa?</h2>
      <router-link v-if="!currentUser" to="/login" class="button is-danger">Registra't i afegeix-la!</router-link>
      <router-link v-if="currentUser" :to="`/edita`" class="button is-danger">Crea-la!</router-link>

    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");
import MyBoxes from '@/components/MyBoxes'
import AllBoxes from '@/components/AllBoxes'
import MyDownloads from '@/components/MyDownloads'


export default {
  data() {
    return {      
      showEmailSent: false,
      urlBase: process.env.URLBASE,
      timeout: 0
    };
  },
  components: {
      MyBoxes, AllBoxes, MyDownloads
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  }
};
</script>
<style scoped>
.section {
  padding: 3rem 0;
}
#dashboard{
  margin-top: -30px;
}
.desc{
  margin-bottom: 1rem;
  white-space: pre-line;
  color: #727475;
}
.mt-2{
  margin-top: 2rem;
}
.is-at-header{
margin-top: 3rem;  
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue